module.exports = __webpack_public_path__ + "img/team-bg.3839c49d.webp";